// 主办自销小程序
import Url from '../utils/url';
export default {
  appName: 'wxapp_activeapp',
  useKNB: false,
  sellChannel: 19,
  theme: 'maoyan',
  ajaxUrl: '//wx.maoyan.com/maoyansh/myshow/ajax',
  ajaxBetaUrl: '//m.51ping.com/myshow/ajax',
  hostPrefix: '//show.maoyan.com/',
  hostBetaPrefix: '//show.test.maoyan.com/',
  getUserInfo: function getUserInfo() {
    return {
      token: Url.getQuery('_token') || Url.getHashQuery('_token')
    };
  },
  getLocation: function getLocation() {
    return {
      lat: Url.getQuery('_lat') || Url.getHashQuery('_lat') || 31.231706,
      lng: Url.getQuery('_lng') || Url.getHashQuery('_lng') || 121.472644
    };
  },
  getCity: function getCity() {
    return {
      cityId: Url.getQuery('_cityId') || Url.getHashQuery('_cityId')
    };
  }
};